import {
  EntrancePlantDetailDTO,
  GateGuestDTO,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import GuestItem from './GuestItem/GuestItem.vue';
import GuestDetailsEdit from './GuestDetailsEdit/GuestDetailsEdit.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import DialogAddGuest from './DialogAddGuest/DialogAddGuest.vue';
import DialogInfo from '@/views/components/DialogInfo/DialogInfo.vue';

enum GuestTab {
  active = 'active',
  expired = 'expired',
}

@Options({
  name: 'EntrancePlantGuests',
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {
    GuestItem,
    DialogAddGuest,
    GuestDetailsEdit,
    DialogInfo
  },
  emits: ['update-list'],
})
export default class EntrancePlantGuests extends Vue {
  guestSelected: GateGuestDTO | null = null;
  GuestTab = GuestTab;
  currentEntrancePlant!: EntrancePlantDetailDTO;
  tabSelected: GuestTab = GuestTab.active;
  changingGuest = false;
  isOneTime = false;
  isVisibleAddGuest = false;
  isVisibleMaxEntity = false;

  async mounted() {}

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  get guests() {
    return this.currentEntrancePlant.gateGuests;
  }

  get guestsList() {
    let guestsFilteredList: GateGuestDTO[] = [];
    const today = Date.parse(new Date().toDateString());

    if (this.guests) {
      switch (this.tabSelected) {
        case GuestTab.active:
          guestsFilteredList = this.guests.filter(
            (guest) =>
              !guest.durationUntil || guest.durationUntil.getTime() >= today
          );
          break;

        case GuestTab.expired:
          guestsFilteredList = this.guests.filter(
            (guest) =>
              guest.durationUntil && guest.durationUntil.getTime() < today
          );
          break;
      }
    }

    return guestsFilteredList;
  }

  handleTabClick(event: { index: number }) {
    this.setSelectionCriteria(
      event.index === 0 ? GuestTab.active : GuestTab.expired
    );
  }

  setSelectionCriteria(selectionCriteria: GuestTab) {
    this.guestSelected = null;
    this.tabSelected = selectionCriteria;
  }

  showGuestDetail(guest: GateGuestDTO | null) {
    this.changingGuest = true;

    setTimeout(() => {
      this.guestSelected = guest;
      this.changingGuest = false;
    }, 300);
  }

  checkIfCanAddGuest() {
    if (this.currentEntrancePlant.gateGuests!.length < 100)
      return true;
    else {
      this.isVisibleMaxEntity = true;
      return false;
    }
  }

  toggleAddGuest(oneTime: boolean) {
    if (!this.checkIfCanAddGuest()) return;
    this.isOneTime = oneTime;
    this.isVisibleAddGuest = !this.isVisibleAddGuest;
  }

  toggleMaxEntity() {
    this.isVisibleMaxEntity = !this.isVisibleMaxEntity;
  }

  async handleDeleteGuest(guestId: string) {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await plantsClient.guestDELETE(
        this.currentEntrancePlant.desktopId as number,
        guestId
      );

      this.$emit('update-list');
      this.showGuestDetail(null);
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: this.$t('AppResourceEP.GateGuestBannerDeleted'),
          closable: false,
          life: 3000,
        });
      }, 1500);
    } catch {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleUpdateList() {
    this.$emit('update-list');
    if (this.guestSelected) {
      this.guestSelected = this.currentEntrancePlant.gateGuests!.find(
        (guest) => guest.id === this.guestSelected!.id
      ) ?? null;
    }
  }
}
